<label class="esf-form-item__label" *ngIf="label">{{ label }}<app-optional *ngIf="optional"></app-optional></label>
<div class="esf-stepper">
  <button (click)="decrement()"
          type="button"
          [disabled]="controlValue <= min"
          class="esf-button esf-button--outlined esf-button--icon esf-stepper__button esf-stepper__button--minus"
          [class.esf-button--icon-small]="!smallButtons">
    <svg class="esf-icon" width="16" height="16">
      <use xlink:href="#esf-icon-minus"></use>
    </svg>
  </button>
  <input class="esf-form-item__field esf-stepper__field"
         type="number"
         name="stepper"
         pattern="[0-9]*"
         style="min-width: 65px;"
         [min]="min" [max]="max"
         [id]="id"
         [formControl]="formControl">
  <button (click)="increment()"
          type="button"
          [disabled]="controlValue >= max"
          class="esf-button esf-button--outlined esf-button--icon esf-stepper__button esf-stepper__button--plus"
          [class.esf-button--icon-small]="!smallButtons">
    <svg class="esf-icon" width="16" height="16">
      <use xlink:href="#esf-icon-plus"></use>
    </svg>
  </button>
</div>
